export const Data = [
  {
    data: [
      {
        title: "About Color",
        description: `Colors are an integral part of our lives. They help in identifying things, their nature, taste and much more. We observe lakhs or thousands of colors in a day and our mind immediately differentiate between them. Some of them appeal us and look beautiful and some of them do not. But, they are definitely strong enough to put a strong impact on our mind and mood. That is why we have also categorized some colors as the symbol of auspiciousness or inauspiciousness. But, what is the secret of colors that affect our mind in such a great manner? Color therapy is also a very famous treatment for curing really complicated diseases. But, before going for a therapy it is important to understand the affect and power that colors posses. For understanding the power of colors in detail, read the colorful articles about 'Color Therapy'.`,
      },
    ],
  },
];
